var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-contextmenu',{ref:"contextmenu"},[_c('v-contextmenu-item',{on:{"click":_vm.handleClick}},[_vm._v("自定义菜单项")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }